// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    padding: 0;
    overflow: hidden;
    font-family: Arial, sans-serif;
    background: transparent;
}

#avatar-container {
    width: 100vw;
    height: 100vh;
    background: transparent;
}

canvas {
    display: block;
    background: transparent;
}

#stop-button {
    position: fixed;
    bottom: 20px;
    left: 50%;
    width: auto;
    height: auto;
    padding: 0;
    background: none;
    color: #e31212;
    border: none;
    font-size: 28px;
    cursor: pointer;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
}

#stop-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
}

#stop-button:hover:not(:disabled) {
    transform: scale(1.15);
}

#stop-button:active:not(:disabled) {
    transform: scale(0.95);
}

/* Remove speaking class styles - keep red always */
#stop-button.speaking {
    color: #c4314b;
}

#stop-button.speaking:hover:not(:disabled) {
    transform: scale(1.15);
}

#settings-button {
    position: fixed;
    top: 20px;
    left: 390px;
    padding: 11px 11px;
    background: rgba(255, 255, 255, 0.1);
    color: white;
    border: none;
    border-radius: 12px;
    font-size: 20px;
    cursor: pointer;
    z-index: 1001;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;
}

#settings-button:hover {
    background: rgba(255, 255, 255, 0.2);
}

#settings-button:active {
    transform: scale(0.95);
}

#settings-panel {
    position: fixed;
    top: 0;
   right: -100%;
    width: 100%;
    /* width: 200px; */
    height: 100vh;
    background: rgba(30, 30, 30, 0.95);
    backdrop-filter: blur(10px);
    color: white;
    z-index: 1000;
    transition: right 0.3s ease;
    overflow-y: auto;
    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.5);
}

#settings-panel.open {
    right: 0;
}

.panel-content {
    padding: 80px 30px 30px 30px;
}

.panel-section {
    margin-bottom: 30px;
}

.panel-section h3 {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
    color: #ffffff;
}

.panel-section-content {
    padding: 10px 0;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.6;
}

.upload-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.file-input-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
    width: 100%;
}

.file-input-wrapper input[type=file] {
    position: absolute;
    left: -9999px;
}

.file-input-label {
    display: block;
    padding: 12px 20px;
    background: rgba(255, 255, 255, 0.1);
    color: white;
    text-align: center;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 2px dashed rgba(255, 255, 255, 0.3);
}

.file-input-label:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
}

.file-input-label i {
    margin-right: 8px;
}

.file-name {
    font-size: 12px;
    color: rgba(255, 255, 255, 0.6);
    margin-top: 5px;
    word-break: break-all;
}

.reset-bg-button {
    padding: 10px 20px;
    background: rgba(220, 53, 69, 0.8);
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
}

.reset-bg-button:hover {
    background: rgba(220, 53, 69, 1);
}

.reset-bg-button:active {
    transform: scale(0.98);
}

.position-buttons {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.position-btn {
    flex: 1;
    min-width: 80px;
    padding: 12px 16px;
    background: rgba(255, 255, 255, 0.1);
    color: white;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
}

.position-btn:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
}

.position-btn.active {
    background: rgba(66, 153, 225, 0.8);
    border-color: rgba(66, 153, 225, 1);
    box-shadow: 0 0 10px rgba(66, 153, 225, 0.5);
}

.position-btn:active {
    transform: scale(0.98);
}

.avatar-buttons {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.avatar-btn {
    flex: 1;
    min-width: 100px;
    padding: 12px 16px;
    background: rgba(255, 255, 255, 0.1);
    color: white;
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
}

.avatar-btn:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.5);
}

.avatar-btn.active {
    background: rgba(139, 92, 246, 0.8);
    border-color: rgba(139, 92, 246, 1);
    box-shadow: 0 0 10px rgba(139, 92, 246, 0.5);
}

.avatar-btn:active {
    transform: scale(0.98);
}

.avatar-btn i {
    margin-right: 6px;
}

/* Kevin Custom Controls Panel */
#kevin-controls-panel {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1001;
    max-height: 90vh;
    overflow-y: auto;
}

.kevin-controls-container {
    background: rgba(30, 30, 30, 0.95);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
    min-width: 280px;
    max-width: 320px;
}

.controls-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 20px;
    border-bottom: 2px solid rgba(255, 255, 255, 0.2);
}

.controls-header h3 {
    color: white;
    margin: 0;
    font-size: 18px;
    font-weight: 600;
}

.toggle-btn {
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: white;
    width: 30px;
    height: 30px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 18px;
    line-height: 1;
    transition: all 0.2s ease;
}

.toggle-btn:hover {
    background: rgba(255, 255, 255, 0.2);
}

.controls-content {
    padding: 15px 20px;
    max-height: 70vh;
    overflow-y: auto;
    transition: all 0.3s ease;
}

.controls-content.collapsed {
    display: none;
}

.control-section {
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.control-section:last-of-type {
    border-bottom: none;
}

.control-section h4 {
    color: #4299e1;
    margin: 0 0 12px 0;
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.control-group {
    margin-bottom: 12px;
}

.control-group label {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: rgba(255, 255, 255, 0.9);
    font-size: 13px;
    margin-bottom: 6px;
    font-weight: 500;
}

.control-group label span {
    color: #4299e1;
    font-weight: 600;
    min-width: 50px;
    text-align: right;
}

.control-group input[type="range"] {
    width: 100%;
    height: 6px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 3px;
    outline: none;
    -webkit-appearance: none;
    cursor: pointer;
}

.control-group input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 16px;
    height: 16px;
    background: #4299e1;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.2s ease;
}

.control-group input[type="range"]::-webkit-slider-thumb:hover {
    background: #3182ce;
    transform: scale(1.15);
}

.control-group input[type="range"]::-webkit-slider-thumb:active {
    transform: scale(0.95);
}

.control-group input[type="range"]::-moz-range-thumb {
    width: 16px;
    height: 16px;
    background: #4299e1;
    border-radius: 50%;
    cursor: pointer;
    border: none;
    transition: all 0.2s ease;
}

.control-group input[type="range"]::-moz-range-thumb:hover {
    background: #3182ce;
    transform: scale(1.15);
}

.control-group input[type="range"]::-moz-range-thumb:active {
    transform: scale(0.95);
}

.reset-controls-btn {
    width: 100%;
    padding: 12px;
    background: rgba(220, 53, 69, 0.8);
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    transition: all 0.3s ease;
    margin-top: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.reset-controls-btn:hover {
    background: rgba(220, 53, 69, 1);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);
}

.reset-controls-btn:active {
    transform: translateY(0);
}

/* Scrollbar styling for controls panel */
.controls-content::-webkit-scrollbar {
    width: 6px;
}

.controls-content::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
    border-radius: 3px;
}

.controls-content::-webkit-scrollbar-thumb {
    background: rgba(66, 153, 225, 0.5);
    border-radius: 3px;
}

.controls-content::-webkit-scrollbar-thumb:hover {
    background: rgba(66, 153, 225, 0.7);
}

`, "",{"version":3,"sources":["webpack://./src/client/css/avatar.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,eAAe;IACf,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,mDAAmD;AACnD;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,aAAa;IACb,yCAAyC;IACzC,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,MAAM;GACP,YAAY;IACX,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,kCAAkC;IAClC,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,iDAAiD;IACjD,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,eAAe;IACf,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;IACnC,mCAAmC;IACnC,4CAA4C;AAChD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,0CAA0C;IAC1C,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;IACnC,mCAAmC;IACnC,4CAA4C;AAChD;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;AACrB;;AAEA,gCAAgC;AAChC;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,iDAAiD;AACrD;;AAEA;IACI,YAAY;IACZ,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,iDAAiD;AACrD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,aAAa;IACb,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,yCAAyC;AACzC;IACI,UAAU;AACd;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;AACvC","sourcesContent":["body {\r\n    margin: 0;\r\n    padding: 0;\r\n    overflow: hidden;\r\n    font-family: Arial, sans-serif;\r\n    background: transparent;\r\n}\r\n\r\n#avatar-container {\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background: transparent;\r\n}\r\n\r\ncanvas {\r\n    display: block;\r\n    background: transparent;\r\n}\r\n\r\n#stop-button {\r\n    position: fixed;\r\n    bottom: 20px;\r\n    left: 50%;\r\n    width: auto;\r\n    height: auto;\r\n    padding: 0;\r\n    background: none;\r\n    color: #e31212;\r\n    border: none;\r\n    font-size: 28px;\r\n    cursor: pointer;\r\n    z-index: 1000;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n#stop-button:disabled {\r\n    opacity: 0.7;\r\n    cursor: not-allowed;\r\n}\r\n\r\n#stop-button:hover:not(:disabled) {\r\n    transform: scale(1.15);\r\n}\r\n\r\n#stop-button:active:not(:disabled) {\r\n    transform: scale(0.95);\r\n}\r\n\r\n/* Remove speaking class styles - keep red always */\r\n#stop-button.speaking {\r\n    color: #c4314b;\r\n}\r\n\r\n#stop-button.speaking:hover:not(:disabled) {\r\n    transform: scale(1.15);\r\n}\r\n\r\n#settings-button {\r\n    position: fixed;\r\n    top: 20px;\r\n    left: 390px;\r\n    padding: 11px 11px;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 12px;\r\n    font-size: 20px;\r\n    cursor: pointer;\r\n    z-index: 1001;\r\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n#settings-button:hover {\r\n    background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n#settings-button:active {\r\n    transform: scale(0.95);\r\n}\r\n\r\n#settings-panel {\r\n    position: fixed;\r\n    top: 0;\r\n   right: -100%;\r\n    width: 100%;\r\n    /* width: 200px; */\r\n    height: 100vh;\r\n    background: rgba(30, 30, 30, 0.95);\r\n    backdrop-filter: blur(10px);\r\n    color: white;\r\n    z-index: 1000;\r\n    transition: right 0.3s ease;\r\n    overflow-y: auto;\r\n    box-shadow: -5px 0 15px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n#settings-panel.open {\r\n    right: 0;\r\n}\r\n\r\n.panel-content {\r\n    padding: 80px 30px 30px 30px;\r\n}\r\n\r\n.panel-section {\r\n    margin-bottom: 30px;\r\n}\r\n\r\n.panel-section h3 {\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n    margin-bottom: 15px;\r\n    padding-bottom: 10px;\r\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\r\n    color: #ffffff;\r\n}\r\n\r\n.panel-section-content {\r\n    padding: 10px 0;\r\n    color: rgba(255, 255, 255, 0.8);\r\n    line-height: 1.6;\r\n}\r\n\r\n.upload-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.file-input-wrapper {\r\n    position: relative;\r\n    overflow: hidden;\r\n    display: inline-block;\r\n    width: 100%;\r\n}\r\n\r\n.file-input-wrapper input[type=file] {\r\n    position: absolute;\r\n    left: -9999px;\r\n}\r\n\r\n.file-input-label {\r\n    display: block;\r\n    padding: 12px 20px;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    color: white;\r\n    text-align: center;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    border: 2px dashed rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.file-input-label:hover {\r\n    background: rgba(255, 255, 255, 0.2);\r\n    border-color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.file-input-label i {\r\n    margin-right: 8px;\r\n}\r\n\r\n.file-name {\r\n    font-size: 12px;\r\n    color: rgba(255, 255, 255, 0.6);\r\n    margin-top: 5px;\r\n    word-break: break-all;\r\n}\r\n\r\n.reset-bg-button {\r\n    padding: 10px 20px;\r\n    background: rgba(220, 53, 69, 0.8);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    font-size: 14px;\r\n}\r\n\r\n.reset-bg-button:hover {\r\n    background: rgba(220, 53, 69, 1);\r\n}\r\n\r\n.reset-bg-button:active {\r\n    transform: scale(0.98);\r\n}\r\n\r\n.position-buttons {\r\n    display: flex;\r\n    gap: 10px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.position-btn {\r\n    flex: 1;\r\n    min-width: 80px;\r\n    padding: 12px 16px;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    color: white;\r\n    border: 2px solid rgba(255, 255, 255, 0.3);\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    text-align: center;\r\n}\r\n\r\n.position-btn:hover {\r\n    background: rgba(255, 255, 255, 0.2);\r\n    border-color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.position-btn.active {\r\n    background: rgba(66, 153, 225, 0.8);\r\n    border-color: rgba(66, 153, 225, 1);\r\n    box-shadow: 0 0 10px rgba(66, 153, 225, 0.5);\r\n}\r\n\r\n.position-btn:active {\r\n    transform: scale(0.98);\r\n}\r\n\r\n.avatar-buttons {\r\n    display: flex;\r\n    gap: 10px;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.avatar-btn {\r\n    flex: 1;\r\n    min-width: 100px;\r\n    padding: 12px 16px;\r\n    background: rgba(255, 255, 255, 0.1);\r\n    color: white;\r\n    border: 2px solid rgba(255, 255, 255, 0.3);\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    font-size: 14px;\r\n    font-weight: 500;\r\n    text-align: center;\r\n}\r\n\r\n.avatar-btn:hover {\r\n    background: rgba(255, 255, 255, 0.2);\r\n    border-color: rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.avatar-btn.active {\r\n    background: rgba(139, 92, 246, 0.8);\r\n    border-color: rgba(139, 92, 246, 1);\r\n    box-shadow: 0 0 10px rgba(139, 92, 246, 0.5);\r\n}\r\n\r\n.avatar-btn:active {\r\n    transform: scale(0.98);\r\n}\r\n\r\n.avatar-btn i {\r\n    margin-right: 6px;\r\n}\r\n\r\n/* Kevin Custom Controls Panel */\r\n#kevin-controls-panel {\r\n    position: fixed;\r\n    top: 20px;\r\n    right: 20px;\r\n    z-index: 1001;\r\n    max-height: 90vh;\r\n    overflow-y: auto;\r\n}\r\n\r\n.kevin-controls-container {\r\n    background: rgba(30, 30, 30, 0.95);\r\n    backdrop-filter: blur(10px);\r\n    border-radius: 12px;\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);\r\n    min-width: 280px;\r\n    max-width: 320px;\r\n}\r\n\r\n.controls-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 15px 20px;\r\n    border-bottom: 2px solid rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.controls-header h3 {\r\n    color: white;\r\n    margin: 0;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n}\r\n\r\n.toggle-btn {\r\n    background: rgba(255, 255, 255, 0.1);\r\n    border: none;\r\n    color: white;\r\n    width: 30px;\r\n    height: 30px;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    font-size: 18px;\r\n    line-height: 1;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.toggle-btn:hover {\r\n    background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.controls-content {\r\n    padding: 15px 20px;\r\n    max-height: 70vh;\r\n    overflow-y: auto;\r\n    transition: all 0.3s ease;\r\n}\r\n\r\n.controls-content.collapsed {\r\n    display: none;\r\n}\r\n\r\n.control-section {\r\n    margin-bottom: 20px;\r\n    padding-bottom: 15px;\r\n    border-bottom: 1px solid rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.control-section:last-of-type {\r\n    border-bottom: none;\r\n}\r\n\r\n.control-section h4 {\r\n    color: #4299e1;\r\n    margin: 0 0 12px 0;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n.control-group {\r\n    margin-bottom: 12px;\r\n}\r\n\r\n.control-group label {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    color: rgba(255, 255, 255, 0.9);\r\n    font-size: 13px;\r\n    margin-bottom: 6px;\r\n    font-weight: 500;\r\n}\r\n\r\n.control-group label span {\r\n    color: #4299e1;\r\n    font-weight: 600;\r\n    min-width: 50px;\r\n    text-align: right;\r\n}\r\n\r\n.control-group input[type=\"range\"] {\r\n    width: 100%;\r\n    height: 6px;\r\n    background: rgba(255, 255, 255, 0.2);\r\n    border-radius: 3px;\r\n    outline: none;\r\n    -webkit-appearance: none;\r\n    cursor: pointer;\r\n}\r\n\r\n.control-group input[type=\"range\"]::-webkit-slider-thumb {\r\n    -webkit-appearance: none;\r\n    appearance: none;\r\n    width: 16px;\r\n    height: 16px;\r\n    background: #4299e1;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.control-group input[type=\"range\"]::-webkit-slider-thumb:hover {\r\n    background: #3182ce;\r\n    transform: scale(1.15);\r\n}\r\n\r\n.control-group input[type=\"range\"]::-webkit-slider-thumb:active {\r\n    transform: scale(0.95);\r\n}\r\n\r\n.control-group input[type=\"range\"]::-moz-range-thumb {\r\n    width: 16px;\r\n    height: 16px;\r\n    background: #4299e1;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    border: none;\r\n    transition: all 0.2s ease;\r\n}\r\n\r\n.control-group input[type=\"range\"]::-moz-range-thumb:hover {\r\n    background: #3182ce;\r\n    transform: scale(1.15);\r\n}\r\n\r\n.control-group input[type=\"range\"]::-moz-range-thumb:active {\r\n    transform: scale(0.95);\r\n}\r\n\r\n.reset-controls-btn {\r\n    width: 100%;\r\n    padding: 12px;\r\n    background: rgba(220, 53, 69, 0.8);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 8px;\r\n    cursor: pointer;\r\n    font-size: 14px;\r\n    font-weight: 600;\r\n    transition: all 0.3s ease;\r\n    margin-top: 10px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n}\r\n\r\n.reset-controls-btn:hover {\r\n    background: rgba(220, 53, 69, 1);\r\n    transform: translateY(-2px);\r\n    box-shadow: 0 4px 12px rgba(220, 53, 69, 0.4);\r\n}\r\n\r\n.reset-controls-btn:active {\r\n    transform: translateY(0);\r\n}\r\n\r\n/* Scrollbar styling for controls panel */\r\n.controls-content::-webkit-scrollbar {\r\n    width: 6px;\r\n}\r\n\r\n.controls-content::-webkit-scrollbar-track {\r\n    background: rgba(255, 255, 255, 0.05);\r\n    border-radius: 3px;\r\n}\r\n\r\n.controls-content::-webkit-scrollbar-thumb {\r\n    background: rgba(66, 153, 225, 0.5);\r\n    border-radius: 3px;\r\n}\r\n\r\n.controls-content::-webkit-scrollbar-thumb:hover {\r\n    background: rgba(66, 153, 225, 0.7);\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
